import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import obv from './modules/obv'
import obmen from './modules/obmen'
import favorites from './modules/favorites'
import search from './modules/search'
import dialogs from './modules/dialogs'
import podat from './modules/podat'
Vue.use(Vuex)
export default new Vuex.Store({
    modules:{
     user,  obv,
      favorites, search, dialogs, podat, obmen
    }
})